var OptionItem = /** @class */ (function () {
    function OptionItem(key, name) {
        this.name = '';
        this.key = key;
        this.name = name;
    }
    return OptionItem;
}());
export { OptionItem };
